// Google Ads (gtag) helpers + Consent Mode v2.
export const AW_ID = "AW-18509467087";
export const CONVERSIONS = {
  booking: "AW-18509467087/plrTCK6UpZ0dEM-bgPpE",
  phone: "AW-18509467087/VbG9CMW0np0dEM-bgPpE",
};

export const CONSENT_KEY = "cookie-consent-v2";

export function gtag() {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag.apply(window, arguments);
  }
}

// Map the user's granular choice to Consent Mode v2 and push the update.
export function applyConsent({ analytics = false, marketing = false }) {
  gtag("consent", "update", {
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
    analytics_storage: analytics ? "granted" : "denied",
  });
}

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function storeConsent(choice) {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(choice));
  } catch {
    /* ignore */
  }
}

// Booking conversion — fires once per booking id (guarded via localStorage).
export function trackBookingConversion({ id, price }) {
  if (!id) return;
  const key = `gads-conv-${id}`;
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch {
    /* ignore */
  }
  gtag("event", "conversion", {
    send_to: CONVERSIONS.booking,
    value: typeof price === "number" ? price : Number(price) || 0,
    currency: "EUR",
    transaction_id: String(id),
  });
}

export function trackPhoneConversion() {
  gtag("event", "conversion", { send_to: CONVERSIONS.phone });
}
